import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";
// import 'moment/locale/ja';
// import moment from 'moment';
import moment from "moment/moment";
import SignOut from "../SignOut/SignOut";

const Sidebar = ({ loading, dispatch_post_authout }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const [active_tab, set_active_tab] = useState("");
  const [modalSignOut, set_modalSignOut] = useState(false);

  return (
    <>
      <SignOut
        loading={loading}
        modal={modalSignOut}
        close_modal={() => {
          set_modalSignOut(false);
        }}
        dispatch_post_authout={dispatch_post_authout}
      />
      <div
        className="sidebar"
        data-color="purple"
        data-background-color="white"
      >
        <div className="logo">
          <a
            href="index.html"
            className="simple-text logo-mini"
            onClick={(e) => {
              e.preventDefault();
              window.jQuery(".navbar-toggler").click();
              history.push({
                pathname: `/top`,
                nonce: moment().unix(),
              });
              window.scroll(0, 0);
            }}
          >
            <img src="../images/brand.svg" width={70} />
          </a>
          <a
            href="index.html"
            className="simple-text logo-normal"
            onClick={(e) => {
              e.preventDefault();
              window.jQuery(".navbar-toggler").click();
              history.push({
                pathname: `/top`,
                nonce: moment().unix(),
              });
              window.scroll(0, 0);
            }}
          >
            {t("SC WORLD EXCHANGE")}
          </a>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            <li className={`nav-item `}>
              <a
                href="#collapseExch"
                className="nav-link"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="collapseExch"
              >
                <i className="material-icons">account_balance</i>
                <p>{t("仮想通貨取引")}</p>
              </a>
              <div id="collapseExch" className="collapse py-2">
                <ul className="navbar-nav mt-1">
                  {/* <li
                    className={`nav-item ${
                      active_tab === "exch-simple" ? "active" : ""
                    }`}
                  >
                    <a
                      href="exch-simple.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("exch-simple");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/exch-simple`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">account_balance</i>
                      <p>{t("かんたん売買")}</p>
                    </a>
                  </li> */}
                  <li
                    className={`nav-item ${
                      active_tab === "exch-market" ? "active" : ""
                    }`}
                  >
                    <a
                      href="exch-market.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("exch-market");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/exch-market`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">account_balance</i>
                      <p>{t("かんたん売買")}</p>
                    </a>
                  </li>
                  <li
                    className={`nav-item ${
                      active_tab === "exch-advanced" ? "active" : ""
                    }`}
                  >
                    <a
                      href="exch-advanced.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("exch-advanced");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/exch-advanced`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">account_balance</i>
                      <p>{t("オーダーブック売買")}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li
              id="nav_pay"
              className={`nav-item ${active_tab === "pay" ? "active" : ""}`}
            >
              <a
                href="pay.html"
                className="nav-link"
                onClick={(e) => {
                  set_active_tab("pay");
                  e.preventDefault();
                  // window.jQuery("#nav_pay").addClass("active");
                  window.jQuery(".navbar-toggler").click();
                  // window.jQuery("#nav_pay").click();
                  history.push({
                    pathname: `/pay`,
                    nonce: moment().unix(),
                  });
                  window.scroll(0, 0);
                  // window.location.reload();
                  // window.location.href = "/pay"
                }}
              >
                <i className="material-icons">payment</i>
                <p>{t("入出金")}</p>
              </a>
            </li>
            <li className={`nav-item `}>
              <a
                href="#collapseLog"
                className="nav-link"
                data-toggle="collapse"
                role="button"
                aria-expanded="false"
                aria-controls="collapseLog"
              >
                <i className="material-icons">history</i>
                <p>{t("取引履歴")}</p>
              </a>
              <div id="collapseLog" className="collapse py-2">
                <ul className="navbar-nav mt-1">
                  <li
                    className={`nav-item ${
                      active_tab === "historiesOrderings" ? "active" : ""
                    }`}
                  >
                    <a
                      href="log-undecided.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("historiesOrderings");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/historiesOrderings`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">history</i>
                      <p>{t("注文中")}</p>
                    </a>
                  </li>
                  <li
                    className={`nav-item ${
                      active_tab === "historiesOrders" ? "active" : ""
                    }`}
                  >
                    <a
                      href="log-purchase.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("historiesOrders");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/historiesOrders`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">history</i>
                      <p>{t("注文履歴")}</p>
                    </a>
                  </li>
                  <li
                    className={`nav-item ${
                      active_tab === "historiesTransactions" ? "active" : ""
                    }`}
                  >
                    <a
                      href="log-transaction.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("historiesTransactions");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/historiesTransactions`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">history</i>
                      <p>{t("トランザクション履歴")}</p>
                    </a>
                  </li>
                  <li
                    className={`nav-item ${
                      active_tab === "historiesAffiliates" ? "active" : ""
                    }`}
                  >
                    <a
                      href="log-transaction.html"
                      className="nav-link"
                      onClick={(e) => {
                        set_active_tab("historiesAffiliates");
                        e.preventDefault();
                        window.jQuery(".navbar-toggler").click();

                        history.push({
                          pathname: `/historiesAffiliates`,
                          nonce: moment().unix(),
                        });
                        window.scroll(0, 0);
                      }}
                    >
                      <i className="material-icons">history</i>
                      <p>{t("アフィリエイト履歴")}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            {/*           <li className={`nav-item ${active_tab === "dashboard" ? "active" : ""}`}>

            <a
              href="support.html"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                window.jQuery(".navbar-toggler").click();

                history.push({
                  pathname: `/dashboard`,
                  nonce: moment().unix(),
                });
                window.scroll(0, 0);
              }}
            >
              <i className="material-icons">headset_mic</i>
              <p>サポート</p>
            </a>
          </li> */}
            <li
              className={`nav-item ${
                active_tab === "settings" ? "active" : ""
              }`}
            >
              <a
                href="settings.html"
                className="nav-link"
                onClick={(e) => {
                  set_active_tab("settings");
                  e.preventDefault();
                  window.jQuery(".navbar-toggler").click();

                  history.push({
                    pathname: `/settings`,
                    nonce: moment().unix(),
                  });
                  window.scroll(0, 0);
                }}
              >
                <i className="material-icons">settings</i>
                <p>{t("アカウント設定")}</p>
              </a>
            </li>
            <li className={`nav-item `}>
              <a
                href="javascript:void(0);"
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  set_modalSignOut(true);
                }}
              >
                <i className="material-icons">logout</i>
                <p>{t("サインアウト")}</p>
              </a>
            </li>
            <li className={`nav-item `}>
              <a
                href="javascript:void(0);"
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  i18n.changeLanguage("ja");
                  sessionStorage.setItem("AcceptLanguage", "ja");
                }}
              >
                <i className="material-icons">settings</i>
                <p>{t("日本語")}</p>
              </a>
            </li>
            <li className={`nav-item `}>
              <a
                href="javascript:void(0);"
                className="nav-link"
                onClick={(e) => {
                  e.preventDefault();
                  i18n.changeLanguage("en");
                  sessionStorage.setItem("AcceptLanguage", "en");
                }}
              >
                <i className="material-icons">settings</i>
                <p>{t("英語")}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
